import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getLogoUrl } from 'src/app/shared/utils/logo-utils';
import { CompanyPageRequestDto } from 'src/portal/search-api/models/company-page-request-dto';
import { GlobalSearchResultTypeEnum } from 'src/portal/search-api/models/global-search-result-type-enum';
import { CompanyService } from 'src/portal/search-api/services/company.service';
import { CompanyDomain } from '../../services/ai-chat.service';

interface CompanyCard {
  logoUrl: string;
  companyName: string;
  description: string;
  domain: string;
  id:string;
}

@Component({
  selector: 'company-card-component',
  templateUrl: './company-card-component.component.html',
  styleUrls: ['./company-card-component.component.scss']
})
export class CompanyCardComponentComponent implements OnInit {
  @Input() companies: CompanyDomain[] = [];
  companyCards: CompanyCard[] = [];
  isLoading = true;

  constructor(private companyService: CompanyService, private router: Router) { }

  ngOnInit(): void {
    // if (this.companies.length > 0) {
    //   this.fetchCompanyData();
    // }
  }

  private fetchCompanyData(): void {
    this.isLoading = true;
    const body: CompanyPageRequestDto = {
      pageNumber: 0,
      pageSize: 10,
      filters: {
        search: '',
        filterType: GlobalSearchResultTypeEnum.COMPANY,
        website: this.companies.map(c => c.domain),
      },
      sort: []
    };

    this.companyService.findCompanies({ body }).subscribe(
      res => {
        this.companyCards = res.content.map(company => ({
          logoUrl: getLogoUrl(company.website),
          companyName: company.companyName,
          description: company.employeeRange || 'No employee range available',
          domain: company.website,
          id: company.id
        }));
        this.isLoading = false;
      },
      error => {
        console.error('Error fetching company data:', error);
        this.isLoading = false;
      }
    );
  }

  ngOnChanges(): void {
    if (this.companies.length > 0) {
      this.fetchCompanyData();
    }
  }

  goToCompany(id){
    this.router.navigate(['/company', id]);
  }
}
